module.exports = __webpack_public_path__ + "img/promosyon-basarili.5e716cec.gif";